var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        staticClass: "table-svg-path",
        attrs: {
          d:
            "M7.5 1.5L6.75 2.25H3V3.75H15V2.25H11.25L10.5 1.5H7.5ZM3.75 5.25V15C3.75 15.825 4.425 16.5 5.25 16.5H12.75C13.575 16.5 14.25 15.825 14.25 15V5.25H3.75ZM6 6.75H7.5V15H6V6.75ZM10.5 6.75H12V15H10.5V6.75Z",
          fill: "CurrentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }